/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14.646 15.678L.363 1.395 1.08.678 15.363 14.96l-.717.717z" _fill="#000"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M.363 14.96L14.646.679l.717.717L1.08 15.678l-.717-.717z" _fill="#000"/>'
  }
})
